/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import makeRequest from 'utils/makeRequest';
// import CardList from 'components_v2/common/CardList';
import Link from 'components/Link';
import Card from 'components_v2/common/Card';
import Morebtn from 'components_v2/mobile/Morebtn';
import s from './ArticleshowCards.scss';

const ArticleshowCards = props => {
  const { url, isWapView, msid } = props;
  const [asData, setASData] = useState({
    title: '',
    items: [],
    linkItems: [],
    itemsForMobile: [],
    showHTML: false,
    more: null,
  });
  const stryNo = isWapView ? 10 : 11;
  useEffect(
    () => {
      const finalUrl = `${url}?stryno=${stryNo}&ismobile=${isWapView}`;
      makeRequest
        .get(finalUrl, { isMobile: isWapView }, 'skipfeedengine')
        .catch(err => console.log(err))
        .then(data => {
          if (data && data.status === 200 && data.data) {
            const { title, more = null } = data.data;
            const { data: { items = [] } = {} } = data.data;
            const linkItems = !isWapView ? items.slice(1, 5) : [];
            const itemsForMobile = items.slice(1, 10);
            setASData({
              title: title && title.text,
              items,
              linkItems,
              itemsForMobile,
              showHTML: true,
              more,
            });
          }
        });
    },
    [url, msid],
  );
  const getItem = (item, type, showDescription, cssObj, index) => {
    if (!item || typeof item !== 'object') {
      return null;
    }
    item.image = {
      id: item.imageid,
      width: 200,
    };
    item.des = item.kws;
    let component = '';
    if (type === 'CARD') {
      component = (
        <Card
          data={item}
          showDescription={showDescription}
          isLeadTypeTwo={!isWapView}
          isLeadImageNews={isWapView}
          cssObj={cssObj}
          newga={`click#moreStories_${item.wu || index}`}
        />
      );
    } else if (type === 'LINK') {
      component = (
        <Link
          to={item.wu || item.su}
          className="linktype1"
          data-newga={`click#moreStories_${item.wu || index}`}
        >
          <span>{item.hl}</span>
        </Link>
      );
    } else {
      component = (
        <Card
          data={item}
          cssObj={cssObj}
          newga={`click#moreStories_${item.wu || index}`}
        />
      );
    }
    return component;
  };
  return (
    <div className={s.Bottom_CardWrapper}>
      {asData.showHTML && (
        <>
          <h3>{asData.title}</h3>
          <div className="grid_wrapper">
            <div className="col_l_8 col_sm_12">
              {getItem(asData.items[0], 'CARD', !isWapView, undefined, 0)}
            </div>
            {!isWapView && asData.linkItems ? (
              <div className={`${s.links} col_l_4`}>
                {asData.linkItems.map((item, i) =>
                  getItem(item, 'LINK', undefined, undefined, i + 1),
                )}
              </div>
            ) : (
              ''
            )}
          </div>
          <div className={s.bottom_restCards}>
            {isWapView
              ? Array.isArray(asData.itemsForMobile) &&
                asData.itemsForMobile.map((item, i) =>
                  getItem(
                    item,
                    '',
                    false,
                    {
                      figureClass: s.cardWrapper,
                    },
                    i + 1,
                  ),
                )
              : Array.isArray(asData.items) &&
                asData.items.slice(5).map((item, i) =>
                  getItem(
                    item,
                    'CARD',
                    false,
                    {
                      figureClass: s.cardWrapper,
                      imgCont: s.thumbImage,
                      titleCont: s.thumbTitle,
                    },
                    i + 5,
                  ),
                )}
          </div>
          {isWapView &&
            asData.more && (
              <Morebtn
                absoluteMoreText={asData.more.text}
                moreLink={asData.more.link}
              />
            )}
        </>
      )}
    </div>
  );
};

ArticleshowCards.propTypes = {
  isWapView: PropTypes.bool,
  msid: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
ArticleshowCards.defaultProps = {
  isWapView: true,
};

export default ArticleshowCards;
